import React, { FunctionComponent } from 'react';
import { Heading } from '@companion-professional/components';

export const PageNotFound: FunctionComponent = () => {
  return (
    <div className="m-10 flex flex-col items-center">
      {/* The 404 is decorative, so it's styled like a (very large) display heading but isn't a heading element. */}
      <Heading level="display" as="p" className="text-6xl text-destructive md:text-6xl">
        404
      </Heading>
      <Heading level="page">Page Not Found</Heading>
    </div>
  );
};
